import { TableField } from '@/interfaces';

function getType(context) {
  return context.$route.path.includes('routecontrols') ? 'tc' : 'site';
}

function getView(context) {
  return context.$route.path.includes('serviceorders') ? 'so' : 'no';
}

function getTypeView(context) {
  return getType(context) + '_' + getView(context);
}

const privs = {
  site_so: 'pr_site_service_order',
  site_no: 'pr_site_notification',
  tc_so: 'pr_tc_service_order',
  tc_no: 'pr_tc_notification'
};

const overviewTitles = {
  so: 'Dienstbevelen',
  no: 'Meldingen'
};

const detailTitles = {
  so: 'Detail Dienstbevel',
  no: 'Detail Melding'
};

const deleteTitles = {
  so: 'dit dienstbevel',
  no: 'deze melding'
};

const urls = {
  site_so: '/sites/serviceorders',
  site_no: '/sites/notifications',
  tc_so: '/routecontrols/serviceorders',
  tc_no: '/routecontrols/notifications'
};

const serviceTypes = {
  so: 0,
  no: 1
};

const filterNames = {
  site_so: 'siteserviceorders',
  site_no: 'sitenotifications',
  tc_so: 'tcserviceorders',
  tc_no: 'tcnotifications'
};

const typeTableFields = {
  site: [
    {
      text: 'Serienummer',
      value: 'serial_nr',
      width: '10%'
    },
    {
      text: 'Installatienummer',
      value: 'installation_nr',
      sortable: false,
      width: '10%'
    }
  ],
  tc: [
    {
      text: 'Serienummermer',
      value: 'serial_nr',
      width: '20%'
    }
  ]
};

export default {
  priv(context) {
    return privs[getTypeView(context)];
  },
  overviewTitle(context) {
    return overviewTitles[getView(context)];
  },
  detailTitle(context) {
    return detailTitles[getView(context)];
  },
  deleteTitle(context) {
    return deleteTitles[getView(context)];
  },
  url(context) {
    return urls[getTypeView(context)];
  },
  apiUrl: '/siteserviceorders/',
  sortBy: ['code'],
  sortDesc: [true],
  addRecord: true,
  newRecord(context) {
    return {
      sitereport_id: null,
      service_type: serviceTypes[getView(context)],
      new_conform_audit: false,
      siteserviceorderstatus_id: 1,
      trafficlight: false,
      highway: false
    };
  },
  deletable: true,
  editable: true,
  filterName(context) {
    return filterNames[getTypeView(context)];
  },
  quickFilter: {
    text: 'Zoeken',
    value: 'misc_search',
    type: 'text'
  },
  advancedSearchFields: [
    {
      text: 'Periode van',
      value: 'date_start',
      type: 'date'
    },
    {
      text: 'Periode tot',
      value: 'date_end',
      type: 'date'
    }
  ],
  tableFields(context) {
    const commonStart: TableField[] = [
      {
        text: 'Nummer',
        value: 'code',
        width: '10%',
        link: urls[getTypeView(context)] + '/{id}'
      }
    ];
    const commonEnd: TableField[] = [
      {
        text: 'Aangemaakt',
        value: 'created_timestamp',
        width: '12.5%',
        filter: 'date'
      },
      {
        text: 'Verstuurd',
        value: 'date_email_sent',
        width: '12.5%',
        filter: 'date'
      },
      {
        text: 'Verwerkt',
        value: 'date_processed',
        width: '12.5%',
        filter: 'date'
      },
      {
        text: 'Ingegeven door',
        value: 'created_user_name',
        width: '15%'
      },
      {
        text: 'Status',
        value: 'state_desc',
        sortable: false,
        width: '10%'
      }
    ];
    const typeFields: TableField[] = typeTableFields[getType(context)];
    return commonStart.concat(typeFields, commonEnd);
  }
};
